export type DedupStyleValue = "A" | "B" | "C" | "ID";

export interface DedupStyleOption {
  value: DedupStyleValue;
  label: string;
  description: string;
  /** Ignored when value is `"ID"` (grouping uses transaction id only). */
  excludeKeys: string[];
}

/** Transaction vault dedup styles (hash exclusions); Style-ID groups by id only. */
export const TRANSACTION_VAULT_DEDUP_STYLES: DedupStyleOption[] = [
  {
    value: "A",
    label: "Style-A",
    description: "Source id and transaction id included, totally safe to delete",
    excludeKeys: ["dc", "dm", "vid", "del"],
  },
  {
    value: "B",
    label: "Style-B",
    description: "Transaction id included, safe to delete",
    excludeKeys: ["dc", "dm", "vid", "del", "srId"],
  },
  {
    value: "C",
    label: "Style-C",
    description:
      "Transaction id included, not safe, single source might be pointing to multiple transactions",
    excludeKeys: ["dc", "dm", "vid", "del", "id", "_id"],
  },
  {
    value: "ID",
    label: "Style-ID",
    description:
      "Transactions with the same id are duplicates; all other fields are ignored when grouping. Cleanup keeps the copy with a valid source row and a real category when possible — safe for silent login cleanup alongside Style-A.",
    excludeKeys: [],
  },
];
